import Button from '@lyra/core/components/Button'
import ButtonGroup from '@lyra/core/components/ButtonGroup'
import { FundingChartAggregatePeriod } from '@lyra/core/constants/chart'
import { formatFundingPeriodLabel } from '@lyra/web/utils/charts'

type FundingChartIntervalSelectorProps = {
  selectedInterval: FundingChartAggregatePeriod
  onChangeInterval: (interval: FundingChartAggregatePeriod) => void
  intervals?: FundingChartAggregatePeriod[]
}

const DEFAULT_INTERVALS = [
  FundingChartAggregatePeriod.OneHour,
  FundingChartAggregatePeriod.EightHours,
  FundingChartAggregatePeriod.OneYear,
]

const FundingChartIntervalSelector = ({
  selectedInterval,
  onChangeInterval,
  intervals = DEFAULT_INTERVALS,
}: FundingChartIntervalSelectorProps) => {
  return (
    <ButtonGroup>
      {intervals.map((interval) => (
        <Button
          key={interval}
          size="sm"
          label={formatFundingPeriodLabel(interval)}
          isSelected={interval === selectedInterval}
          onPress={() => {
            onChangeInterval(interval)
          }}
        />
      ))}
    </ButtonGroup>
  )
}

export default FundingChartIntervalSelector
